export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9222.a345d222.jpg";